module.exports = __webpack_public_path__ + "static/moderator-9d6e44b808b8d948c66844dbb4a0446a.svg";